import {
  hotelGetOptions,
  hotelQueryOptions,
} from '@quoruum/frontend-common/oas/gen/quoruum/@tanstack/react-query.gen';
import { defineEntitySchema } from './base/EntitySchema';

// Read-only, and not in the entity picker: hotels are only used to find comp sets.
export const hotelSchema = defineEntitySchema({
  name: 'hotel',
  label: 'Hotel',
  idField: 'id',
  primaryText: 'name',
  secondaryText: (hotel) => hotel.city?.name ?? '',
  endpoints: {
    query: hotelQueryOptions,
    read: hotelGetOptions,
  },
  fields: [
    { key: 'id', label: 'ID', type: 'string', readOnly: true },
    { key: 'name', label: 'Name', type: 'string', readOnly: true },
    { key: 'city.name', label: 'City', type: 'string', readOnly: true },
    { key: 'address1', label: 'Address', type: 'string', readOnly: true },
    { key: 'type', label: 'Type', type: 'string', readOnly: true },
    { key: 'status', label: 'Status', type: 'string', readOnly: true },
  ],
});
